import FormWrapper from 'components/Form/FormWrapper'
import styled from 'styled-components'
import HistoryTable from './components/HistoryTable'
import { useReconcilationHistory } from 'services/swr/reconcilationHistory'
import { useEffect, useState } from 'react'
import * as qs from 'query-string'
import { useLocation, useHistory } from 'react-router-dom'

const WrapperPage = styled.div`
  min-height: 77vh;
  width: 100%;
  padding: 0 20px 40px;
`

const Page = () => {
  const location = useLocation()
   const history = useHistory()
   const [params, setParams] = useState<any>(() => {
     const query = qs.parse(location.search)
     return {
       page: Number(query.page) || 1,
       per_page: Number(query.per_page) || 25
     }
   })
   useEffect(() => {
     const query = qs.parse(location.search)
     setParams({
       page: Number(query.page) || 1,
       per_page: Number(query.per_page) || 25
     })
   }, [])
   useEffect(() => {
     if (params) {
       const queryString = qs.stringify(params)
       history.push({
         pathname: history.location.pathname,
         search: queryString ? `?${queryString}` : '',
       })
     }
   }, [history, params])
  const { data } = useReconcilationHistory(params)
  const handleChangePanation = (page: number, per_page: number) => setParams({ page, per_page })

  return (
    <WrapperPage>
      <p className='title-page'>Lịch sử đối soát</p>

      <FormWrapper>
        <HistoryTable data={data} setParams={setParams} params={params} />
      </FormWrapper>
    </WrapperPage>
  )
}

export default Page
